import { createRoot } from "react-dom/client";

import App from "./App.js";

addEventListener("DOMContentLoaded", () => {
    const el = document.getElementById("cotizaciones_root");
    const basename = el.dataset.basename.replace(/\/$/, "");

    if (el) {
        const root = createRoot(el);
        // root.render(<App />);
        root.render(<App basename={basename} />);
    }
});
